import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import CloseIcon from '@material-ui/icons/Close';
import i18n from '../../i18n/i18n';

const SlideTransition = (props) => <Slide {...props} direction="up" />;

// `&.MuiSnackbar-root` = two-class specificity, so it overrides MUI's own
// anchorOrigin bottom (24px desktop / 0 mobile) without !important.
const StyledSnackbar = styled(Snackbar)<{ $bottomOffset?: number; $sideMargin?: number }>`
  &.MuiSnackbar-root {
    ${({ $bottomOffset }) => ($bottomOffset ? `bottom: ${$bottomOffset}px !important;` : '')}
    ${({ $sideMargin }) => ($sideMargin != null
    ? `left: ${$sideMargin}px !important; right: ${$sideMargin}px !important; transform: none !important;`
    : '')}
  }
  ${({ $sideMargin }) => ($sideMargin != null
    ? '&.MuiSnackbar-root > * { width: 100% !important; box-sizing: border-box; }'
    : '')}
`;

const NotificationToast: any = ({
  duration,
  message,
  onClose,
  open,
  severity,
  title,
  bottomOffset,
  sideMargin,
}) => (
  <StyledSnackbar
    $bottomOffset={bottomOffset}
    $sideMargin={sideMargin}
    action={(
      <Button
        onClick={onClose}
      >
        <CloseIcon fontSize="small" />
      </Button>
              )}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    autoHideDuration={duration === undefined ? 5000 : duration}
    onClose={onClose}
    open={open}
    TransitionComponent={SlideTransition}
  >
    <Alert
      onClose={onClose}
      severity={severity || 'error'}
    >
      <AlertTitle>{title || i18n.t("operation_failed")}</AlertTitle>
      {message}
    </Alert>
  </StyledSnackbar>
);

export default NotificationToast;
